
import { actions } from '../constants/mainMenu';
import * as types from '../../models/action/main-menu';
import * as typesState from '../../models/pages/main-menu';

export function getMainMenuData(spinnerId?: string, spinnerType?: 'get' | 'set'): types.IMainMenuAction {
    return {
        timestamp: Date.now(),
        type: actions.GET_MAIN_MENU_DATA,
        spinnerId,
        spinnerType
    };
}

export function setMainMenuData(mainMenu: Array<{ staticLink: string, name: string, url: string, classId: string, courseId: string }> | null, spinnerId?: string, spinnerType?: 'get' | 'set'): types.IMainSetMenuAction {
    return {
        mainMenu,
        timestamp: Date.now(),
        type: actions.SET_MAIN_MENU_DATA,
        spinnerId,
        spinnerType
    };
}


export function getMainMenuCourseTabData(): types.IMainCourseMenuTabAction {
    return {
        timestamp: Date.now(),
        type: actions.GET_MAIN_COURSEMENU_TAB_DATA
    };
}

export function setMainMenuCourseTabData(menuPanelItems: Array<{ name: string, type: number, count: number }> | null, tabActiveStatus: number | null, courseSubNavigationTabParam: string | null, courseMenuPanelItemsIsLoaded: boolean): types.IMainCourseMenuTabSetAction {
    return {
        menuPanelItems,
        courseMenuPanelItemsIsLoaded,
        timestamp: Date.now(),
        type: actions.SET_MAIN_COURSEMENU_TAB_DATA,
        tabActiveStatus,
        courseSubNavigationTabParam
    };
}


// tslint:disable-next-line:adjacent-overload-signatures
export function getMainMenuCourseContentData(teacher: boolean, subNavigationParam: string, status: number, spinnerId?: string, spinnerType?: 'get' | 'set'): types.IMainCourseMenuContentAction {
    return {
        activeStatus: status,
        courseSubNavigationParam: subNavigationParam,
        isTeacher: teacher,
        timestamp: Date.now(),
        type: actions.GET_MAIN_COURSEMENU_CONTENT_DATA,
        spinnerId,
        spinnerType
    };
}

export function setMainMenuCourseContentData(mainMenuCourseContent: Array<{ teachers: string, name: string, logoUrl: string, progress: string, classId: string, courseId: string, endDate: string, startDate: string }> | null, spinnerId?: string, spinnerType?: 'get' | 'set'): types.IMainCourseMenuContentSetAction {
    return {
        mainMenuCourseContent,
        timestamp: Date.now(),
        type: actions.SET_MAIN_COURSEMENU_CONTENT_DATA,
        spinnerId,
        spinnerType
    };
}
